import { ReactElement } from "react";

import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { DiscountCodeFieldProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
export const DiscountCodeField = dynamic(
  () => import("./DiscountCodeFieldSsr").then((mod) => mod.DiscountCodeFieldSsr),
  { ssr: false }
) as <T extends FieldValues>(props: DiscountCodeFieldProps<T>) => ReactElement;
